import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { ReactNode } from 'react'

interface Props {
  children?: () => ReactNode
}

const PingTestConfigService = ({ children }: Props) => (
  <AuthenticatedDataRequest
    method='get'
    url={`${TEST_CONFIG_SERVICE}/ping`}
  >
    {children}
  </AuthenticatedDataRequest>
)

export default PingTestConfigService
